import(/* webpackMode: "eager", webpackExports: ["LandingHeader"] */ "/home/runner/work/mdsite4/mdsite4/app/_components/landing-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/mdsite4/mdsite4/app/_components/sections.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/app/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["ChallengeProvider"] */ "/home/runner/work/mdsite4/mdsite4/components/lens/challenge-modal.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/components/lens/lens.css");
;
import(/* webpackMode: "eager", webpackExports: ["Hero","MethodsSection","WhySection","ChallengeSection","ShowcaseSection","FAQSection","FinalCTA"] */ "/home/runner/work/mdsite4/mdsite4/components/lens/sections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkillsSection"] */ "/home/runner/work/mdsite4/mdsite4/components/lens/skills-section.tsx");
